<template>
<div>
  <el-tabs v-model="card_index">
    <el-tab-pane label="待审核" name="list">
      <ThirdPartyTab1 v-if="card_index==='list'" />
    </el-tab-pane>
    <el-tab-pane label="审核中" name="shz">
      <ThirdPartyTab5 v-if="card_index==='shz'" />
    </el-tab-pane>
    <el-tab-pane label="已审核" name="ys">
      <ThirdPartyTab2 v-if="card_index==='ys'" />
    </el-tab-pane>
    <el-tab-pane label="驳回" name="bh">
      <ThirdPartyTab3 v-if="card_index==='bh'" />
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import ThirdPartyTab5 from "./ThirdPartyTab5";
import ThirdPartyTab2 from "./ThirdPartyTab2";
import ThirdPartyTab3 from "./ThirdPartyTab3";
import ThirdPartyTab1 from "./ThirdPartyTab1";

export default {
  name: "ThirdPartyListLayout",
  components: {ThirdPartyTab5, ThirdPartyTab2, ThirdPartyTab3, ThirdPartyTab1},
  data(){
    return{
      card_index:"list"
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty/ThirdPartyListLayout.vue